/**
 * Recently Viewed Manager - Moon Moon Agency
 * Affiche les produits récemment vus (sessionStorage) en réutilisant
 * le rendu serveur de mm-card-product (wishlist, add-to-cart, variantes)
 */

/*********************************************************************************************
 * 🕒 RECENTLY VIEWED MANAGER
 */
const RecentlyViewedManager = {
	config: {
		selectors: {
			section: '.mm-recently-viewed',
			recentContainer: '[data-recent-container]',
		},
		storage: {
			key: 'mm_recently_viewed',
			maxItems: 12,
		},
	},

	init() {
		const sections = window.getElements(this.config.selectors.section);
		if (!sections.length) return;

		sections.forEach(section => this._initRecentlyViewed(section));
		window.log('info', '🕒 [RECENTLY_VIEWED]', 'Initialized');
	},

	/* -------------------------------------------------------------------------
	 * Lecture sessionStorage
	 * ----------------------------------------------------------------------- */

	_getViewed() {
		try {
			const raw = sessionStorage.getItem(this.config.storage.key);
			const handles = JSON.parse(raw || '[]');
			return [...new Set(handles)];
		} catch {
			return [];
		}
	},

	_hideSection(section) {
		section.style.display = 'none';
	},

	async _initRecentlyViewed(section) {
		const container = section.querySelector(this.config.selectors.recentContainer);
		if (!container) return;

		const handles = this._getViewed();
		const limit = parseInt(container.dataset.productsLimit, 10) || 8;
		const toFetch = handles.slice(0, limit);

		if (!toFetch.length) {
			this._hideSection(section);
			return;
		}

		try {
			const cardsHtml = await Promise.all(toFetch.map(handle => this._fetchProductCard(handle)));
			const slides = cardsHtml.filter(Boolean);

			if (!slides.length) {
				this._hideSection(section);
				return;
			}

			container.innerHTML = `
				<div class="mm-recently-viewed__slider splide mm-splide">
					<div class="splide__track mm-overflow-visible mm-w-full">
						<ul class="splide__list">${slides.map(html => `<li class="splide__slide">${html}</li>`).join('')}</ul>
					</div>
				</div>`;

			if (window.wishlistManager) {
				window.wishlistManager.initButtons();
			}

			// Teleport newly injected size panels to <body> — otherwise Splide's
			// transform on .splide__list traps their position:fixed, making them
			// render next to the card instead of over the viewport (see mm_card_product.js).
			if (window.ProductCardManager) {
				window.ProductCardManager.init();
			}

			const splideEl = container.querySelector('.splide');

			if (splideEl && typeof Splide !== 'undefined') {
				splideEl._splide = new Splide(splideEl, this._recentSplideConfig()).mount();
				window.log('info', '🕒 [RECENTLY_VIEWED]', 'Splide mounted');
			}
		} catch (e) {
			window.log('error', '🕒 [RECENTLY_VIEWED]', '_initRecentlyViewed error', { error: e.message });
			this._hideSection(section);
		}
	},

	async _fetchProductCard(handle) {
		try {
			const path = window.location.pathname;
			const languageMatch = path.match(/^\/([a-z]{2})(\/|$)/);
			const languagePrefix = languageMatch ? `/${languageMatch[1]}` : '';

			// cache: 'no-store' — évite un bug WebKit/Safari ou des fetch() concurrents
			// vers des URLs quasi identiques peuvent renvoyer une réponse mise en cache
			// pour un autre handle, faisant apparaitre le meme produit plusieurs fois.
			const response = await fetch(`${languagePrefix}/products/${handle}?view=recently-viewed`, { cache: 'no-store' });
			if (!response.ok) return '';

			const html = await response.text();
			const doc = new DOMParser().parseFromString(html, 'text/html');
			const productCard = doc.querySelector('[data-product-card-view] .mm-product-card');

			return productCard ? productCard.outerHTML : '';
		} catch (e) {
			window.log('error', '🕒 [RECENTLY_VIEWED]', 'Fetch product card failed', { handle, error: e.message });
			return '';
		}
	},

	_recentSplideConfig() {
		const tabletBp = window.TABLET_BREAKPOINT || 990;
		const mobileBp = window.MOBILE_BREAKPOINT || 768;
		return {
			type: 'slide',
			perMove: 1,
			fixedWidth: '212px',
			gap: 15,
			arrows: false,
			pagination: false,
			autoplay: false,
			breakpoints: {
				[tabletBp]: { fixedWidth: false, perPage: 3, gap: 10 },
				[mobileBp]: { fixedWidth: '150px', perPage: 2, gap: 10, arrows: false, pagination: false, padding: { right: '40px' } },
			},
		};
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => RecentlyViewedManager.init());
} else {
	RecentlyViewedManager.init();
}
